<template>
  <div class="content">
    <slot></slot>
  </div>
</template>

<script setup>
</script>

<style scoped>
.content {
  width: 100%;
  min-height: 100vh;
  background-color: #1a1b1b;
  box-sizing: border-box;
}
</style>
